import type { TranslationKey } from "../locales";
import type { Nullable } from "../types";

/**
 * This function maps Webfleet tripmode numeric values to translation keys.
 * @see https://developer.webfleet.com/docs/webfleet-api/functions/showobjectreportextern/#field-definitions
 * @param tripmode
 * @returns
 */
export function getWebfleetTripmodeTranslationKey(tripmode: Nullable<number>): TranslationKey {
	if (!tripmode) return "webfleet.tripmode.unknown_trip_type";
	switch (tripmode) {
		case 1:
			return "webfleet.tripmode.private_trip";
		case 2:
			return "webfleet.tripmode.business_trip";
		case 3:
			return "webfleet.tripmode.commute_trip";
		case 4:
			return "webfleet.tripmode.correction_trip";
		default:
			return "webfleet.tripmode.unknown_trip_type";
	}
}
